import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import toast from 'utils/toast'
import {
  getPermissionConstraints,
  getPermissionMetaDataConstraints,
} from 'action_creators/permissions_constraints'
import { isEmpty } from 'lodash'

const getVariableType = dataType => {
  switch (dataType) {
    case 'string':
      return 'text'
    case 'secret':
      return 'secret'
    case 'number':
      return 'number'
    default:
      return 'text'
  }
}

export const useFetchPermissionData = ({
  profileId,
  permissionName,
  permissionType,
  permissionConstraintTypes,
}) => {
  const dispatch = useDispatch()
  const loading = useSelector(
    state =>
      state.permissionsConstraints.permissionConstraints[
        permissionConstraintTypes[0]
      ]?.status
  )
  const metaDataLoading = useSelector(
    state => state.permissionsConstraints?.permissionMetadataConstraints?.status
  )

  const getMetadataConstraints = async () => {
    try {
      await dispatch(
        getPermissionMetaDataConstraints(
          profileId,
          permissionName,
          permissionType,
          permissionConstraintTypes[0],
          true
        )
      )
    } catch (err) {
      toast({
        title: 'Failed to fetch constraints',
        type: 'error',
        time: 'normal',
      })
    }
  }

  const getPermissionConstraintsData = async () => {
    try {
      return await dispatch(
        getPermissionConstraints(
          profileId,
          permissionName,
          permissionType,
          permissionConstraintTypes[0]
        )
      )
    } catch (err) {
      toast({
        title: 'Failed to fetch permission constraints',
        type: 'error',
        time: 'normal',
      })
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        await getMetadataConstraints()
        await getPermissionConstraintsData()
      } catch (err) {
        toast({
          title: 'Failed to fetch constraints',
          type: 'error',
          time: 'normal',
        })
      }
    }
    fetchData()
  }, [
    profileId,
    permissionName,
    permissionType,
    permissionConstraintTypes,
    dispatch,
  ])

  return { loading: loading === 'LOADING' || metaDataLoading === 'LOADING' }
}

export const useTableData = (metadataConstraints, permissionConstraints) => {
  const [tableData, setTableData] = useState([])

  useEffect(() => {
    if (!isEmpty(metadataConstraints)) {
      const constraintMap =
        permissionConstraints?.result?.reduce((acc, item) => {
          acc[item.name] = item
          return acc
        }, {}) || {}

      const updatedData = metadataConstraints.variables.map(variable => {
        const existing = constraintMap[variable.name] || {}
        return {
          name: variable.name,
          value: existing.value || '',
          systemDefined: existing.systemDefined || false,
          type: getVariableType(variable.dataType),
          mandatory: variable.mandatory,
        }
      })

      setTableData(updatedData)
    }
  }, [metadataConstraints, permissionConstraints])

  return [tableData, setTableData]
}
